import React from "react";

/**
 * <Email /> — renders an email address that bypasses Cloudflare/CDN
 * email obfuscation (which would otherwise show "[email protected]").
 *
 * Displays as: [email protected]
 * mailto: link is preserved.
 *
 * Trick: split the address into user + separator + domain across
 * multiple text nodes and encode the "@" as a Unicode escape at
 * runtime — the CDN's server-side regex only matches literal
 * "[email protected]" patterns in the served HTML, so it leaves
 * this alone.
 */
export default function Email({
  user = "support",
  domain = "forte2.space",
  className = "",
  ariaLabel,
  ...rest
}) {
  const at = "\u0040"; // U+0040 = "@"
  const href = "mailto:" + user + at + domain;
  return (
    <a
      href={href}
      className={className}
      aria-label={ariaLabel || `${user}${at}${domain}`}
      {...rest}
    >
      <span>{user}</span>
      <span aria-hidden="true">{at}</span>
      <span>{domain}</span>
    </a>
  );
}

/**
 * <EmailText /> — inline plain text version of the email (no anchor).
 * Use inside a paragraph where you don't want a clickable link.
 */
export function EmailText({ user = "support", domain = "forte2.space", className = "" }) {
  const at = "\u0040";
  return (
    <span className={className}>
      <span>{user}</span>
      <span aria-hidden="true">{at}</span>
      <span>{domain}</span>
    </span>
  );
}
